import { useEffect, useState } from 'react';

/**
 * Returns `value` only after `delay` ms have passed without it changing.
 * Used to keep server-side search calls quiet while a user is still typing.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => {
      clearTimeout(handle);
    };
  }, [value, delay]);

  return debounced;
}
